import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import globalContext from '../../config/context';
import 'leaflet/dist/leaflet.css';
import '../Maps/Maps.css';
import 'leaflet-draw/dist/leaflet.draw.css';

import {LayersControl, Map, TileLayer, GeoJSON, ZoomControl, ScaleControl, FeatureGroup, Circle} from 'react-leaflet';
import {EditControl} from 'react-leaflet-draw';
import {BingLayer} from 'react-leaflet-bing-v2';

const useStyles = makeStyles((theme) => ({
  body: {},
  map: {},
}));

const MapsBrowser = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian, checkedBphtb}, {setPencarian, setAlert, setLoading}] = useAppContext();
  const {mapRef, baseLayerChange, zoomEnd, dragEnd, checked} = props;

  const state = {
    lat: -2.4806,
    lng: 112.936,
    zoom: 12,
  };

  const {BaseLayer} = LayersControl;
  const bing_key = 'AuhiCJHlGzhg93IqUH_oCpl_-ZUrIE6SPftlyGYUvr9Amx5nzA-WqGcPquyFZl4L';
  const position = [state.lat, state.lng];

  return (
      <div className={classes.body}>
        <div className={classes.map}>
          <Map
              ref={mapRef}
              className="map"
              center={position}
              zoom={state.zoom}
              zoomControl={false}
              onBaseLayerChange={baseLayerChange}
              onZoomEnd={zoomEnd}
              onDragEnd={dragEnd}>
            <LayersControl position="topright">
              <BaseLayer checked name="Open Street Maps">
                <TileLayer
                    attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://www.openstreetmap.org/" target="blank">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </BaseLayer>
              <BaseLayer name="Google Maps">
                <TileLayer
                    attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                    url="https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                />
              </BaseLayer>
              <BaseLayer name="Bing Maps">
                <BingLayer bingkey={bing_key} />
              </BaseLayer>
              <BaseLayer name="Google Satelite">
                <TileLayer
                    attribution='<a href="http://citracom.co.id/" target="blank">PT.Citracom Inti Persada</a> &copy; <a href="https://maps.google.com/" target="blank">GoogleMaps</a> contributors'
                    url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
                />
              </BaseLayer>
            </LayersControl>
            <ZoomControl position="topright" />
            {checked ? null : <ScaleControl />}

            <FeatureGroup>
              <EditControl
                  position="topright"
                  // onEdited={this._onEdited}
                  // onCreated={this._onCreated}
                  // onDeleted={this._onDeleted}
                  // onMounted={this._onMounted}
                  // onEditStart={this._onEditStart}
                  // onEditStop={this._onEditStop}
                  // onDeleteStart={this._onDeleteStart}
                  // onDeleteStop={this._onDeleteStop}
                  draw={{
                    polyline: false,
                    rectangle: false,
                    circle: false,
                  }}
                  edit={{

                  }}
              />
              <Circle center={[51.51, -0.06]} radius={200} />
            </FeatureGroup>
          </Map>
        </div>
      </div>
  );
};

export default MapsBrowser;
